module.exports = __webpack_public_path__ + "static/media/comments-alt.4ca96091.svg";